export const workflowsSettingsPath = () => '/settings/workflows' as const;
